import styled from 'styled-components'
import { GreatPrimer } from '~/components/Typography'

export const Button = styled(GreatPrimer)`
  appearance: none;
  text-decoration: underline;
  border: none;
  padding: 15px 0;
  cursor: pointer;
  background: transparent;
`
